<ng-container *ngIf="article$ | async as article">

  <div class="w-full mx-auto max-w-screen-xl px-4 py-15 md:px-14 md:py-18">
    <div class="text-sm text-center text-primary uppercase font-semibold mb-4" itemscope
      itemtype="https://schema.org/BreadcrumbList">
      <ng-container *ngFor="
          let item of article.data?.attributes?.article_categories.data;
          let last = last;
          let i = index
        ">
        <span itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <a itemprop="item" [routerLink]="['/', activeLang, 'artigos', item.attributes.slug]">
            <span itemprop="name">{{ item.attributes.friendlyName }}</span>
            <meta itemprop="position" content="{{ i + 1 }}" />
          </a>
        </span>
        <span *ngIf="!last">,</span>
      </ng-container>
    </div>

    <h1
      class="text-center text-black-motorbest-500 text-4xl leading-6xl md:text-7xl md:leading-8xl mb-6 md:mb-4 break-words">
      {{ article.data?.attributes?.title }}
    </h1>

    <div class="text-xl font-medium text-center max-w-200 mb-16 mx-auto"
      [innerHTML]="article.data?.attributes?.excerpt"></div>

    <div class="grid grid-cols-1 md:grid-cols-12 grid-flow-row gap-2 justify-center">
      <ng-container *ngIf="article.data?.attributes?.useFeatureImageOnDetail">
        <div class="col-span-1 md:col-span-12">
          <Image [src]="getImageUrl(article.data?.attributes?.featureImage?.data,'full')"
            [bigSrc]="getImageUrl(article.data?.attributes?.featureImage?.data, 'full')"
            [alt]="article.data?.attributes?.featureImage?.data?.name" [class]="'object-cover h-full object-center'">
          </Image>
        </div>
      </ng-container>

      <ng-container *ngFor="
          let widget of article?.data?.attributes?.layout;
          let i = index;
          let first = first;
          let last = last
        ">
        <ng-container *ngIf="widget.__component === 'widgets.image'">
          <div [class]="getResponviceClasses(widget)">
            <widget-image [widget]="widget" (lightbox)="updateGallery($event)" (onImageClick)="light.open()"
              [ref]="light"></widget-image>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'article.block-author'">
          <div class="col-span-1 md:col-span-8 md:col-start-3 lg:col-start-3 xl:col-start-3 ">
            <widget-article-block-author [widget]="{
                config: widget,
                author: article?.data?.attributes?.author,
                date: article?.data?.attributes?.publishDate,
              }"></widget-article-block-author>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.block-title'">
          <div
            [class]="getResponviceClasses(widget) + ' md:col-start-3 lg:col-start-3 xl:col-start-3  getResponviceClasses'">
            <widget-title [widget]="widget" elementClasses="mt-14"></widget-title>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.editor-text'">
          <div
            [class]="getResponviceClasses(widget) + ' md:col-start-3 lg:col-start-3 xl:col-start-3 md:col-span-8  getResponviceClasses'">
            <widgets-editor-text [widget]="widget" elementClasses="mt-14 mb-14"></widgets-editor-text>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.gallery'">
          <div class="col-span-1 md:col-span-12">
            <widget-gallery [widget]="widget" (lightbox)="updateGallery($event)"
              (onImageClick)="light.open()"></widget-gallery>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.video'">
          <div [class]="getResponviceClasses(widget)">
            <widget-video [widget]="widget"></widget-video>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.form'">
          <div class="col-span-1 md:col-span-8 md:col-start-3 lg:col-start-3 xl:col-start-3 ">
            <widget-form [widget]="widget"></widget-form>
          </div>
        </ng-container>

        <ng-container *ngIf="widget.__component === 'widgets.section-image-title-text'">
          <widgets-image-title-text class="col-span-1 md:col-span-12" [widget]="widget"></widgets-image-title-text>
        </ng-container>

      </ng-container>


      <div class="col-span-1 md:col-span-8 md:col-start-3 lg:col-start-3 xl:col-start-3 ">
        <widget-spacer></widget-spacer>
      </div>

      <div class="col-span-1 md:col-span-8 md:col-start-3 lg:col-start-3 xl:col-start-3  flex justify-between">
        <div class="flex article-social">
          <a href="https://www.facebook.com/sharer/sharer.php?u={{ pagelink }}" rel="noopener" target="_blank"
            class="footer__social--item w-10 h-10 rounded-full border border-primary text-primary flex justify-center items-center hover:bg-primary hover:text-white mr-2">
            <mat-icon svgIcon="feather:facebook" color="primary" class="hover:text-white"></mat-icon>
          </a>
          <!-- <a href="https://www.instagram.com/?url={{ pagelink }}" target="_blank" rel="noopener"
            class="footer__social--item w-10 h-10 rounded-full border border-primary text-primary flex justify-center items-center hover:bg-primary hover:text-white mr-2">
            <mat-icon svgIcon="feather:instagram" color="primary" class="hover:text-white"></mat-icon>
          </a> -->
          <a href="https://wa.me/?text={{ pagelink }}" target="_blank" rel="noopener"
            class="footer__social--item w-10 h-10 rounded-full border border-primary text-primary flex justify-center items-center hover:bg-primary hover:text-white mr-2">
            <mat-icon svgIcon="feather:message-circle" color="primary" class="hover:text-white"></mat-icon>
          </a>
          <a href="mailto:?subject={{ article.data?.attributes?.title }};body={{
              pagelink
            }}" target="_blank" rel="noopener"
            class="footer__social--item w-10 h-10 rounded-full border border-primary text-primary flex justify-center items-center hover:bg-primary hover:text-white mr-2">
            <mat-icon svgIcon="feather:mail" color="primary" class="hover:text-white"></mat-icon>
          </a>
        </div>
        <div class="article-tags">
          <button mat-stroked-button color="primary" class="rounded-none border-primary mr-4"
            *ngFor="let tag of article?.data?.attributes?.article_tags.data">
            {{ tag.attributes.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="w-full mx-auto max-w-screen-xl pb-7">
    <widget-news [widget]="{
        layoutFormat: 'xLine',
        name: 'Mais artigos',
        numberOfColumns: 4,
        numberOfArticles: 4,
        showImage: true,
        showDate: true,
        showExcerpt: true,
        showTitle: true,
        article_categories: article?.data?.attributes?.article_categories,
        notIn: article?.data?.id,
      }"></widget-news>
  </div>
</ng-container>

<!-- <div class="w-full mx-auto max-w-screen-xl p-14">
  <div class="text-sm text-center text-primary uppercase font-semibold mb-4">
    história
  </div>
  <h1 class="text-center text-black-motorbest-500 text-7xl leading-8xl mb-4">
    Cinquecento Sport, o micro-GTI
  </h1>
  <div class="text-xl font-medium text-center max-w-200 mb-16 mx-auto">
    Embora não tivesse sido planeada desde o início, a versão Sport do
    Cinquecento apenas continua uma tradição que sempre fez parte dos citadinos
    Fiat.
  </div>

  <div class="bg-slate-200 h-[660px] w-full mb-14"></div>

  <div class="pl-56 pr-56 flex items-center">
    <div class="rounded-full w-18 h-18 border border-primary bg-slate-200"></div>
    <div class="ml-4">
      <div class="font-bold text-md">Hugo Reis</div>
      <div class="text-sm">10 de fevereiro de 2023</div>
    </div>
  </div>

  <div class="pl-56 pr-56 flex items-center text-base leading-4xl text-gray60-500 mt-10 mb-16">
    É sabido que todas as marcas italianas nasceram com a competição
    profundamente enraizada no seu ADN. Apesar da Fiat ter as suas origens nos
    gigantes Itala, com motores chegavam aos 15 litros de capacidade, cedo
    começou a dedicar-se às baixas cilindradas, com modelos como o 508 Balilla.
    Apesar de ser o mais pequeno Fiat, com um motor de apenas 995cc, teve uma
    versão Sport (com derivações) que dominava todas as competições na sua
    classe.
  </div>

  <div class="pl-28 pr-28 grid grid-cols-2 gap-4">
    <div class="bg-slate-200 h-[382px] w-full"></div>
    <div class="bg-slate-200 h-[382px] w-full"></div>
  </div>

  <div class="pl-56 pr-56 flex items-center text-base leading-4xl text-gray60-500 mt-10 mb-16">
    Mais moderno e mais pequeno, o 500 “Topolino”, foi o primeira da linhagem
    500, e nunca teve uma versão desportiva oficial, apesar de ter servido de
    base para inúmeros preparadores e construtores independentes.
    <br /><br />
    A este sucedeu o popular 500 Nuova, em 1957 (e até 1975). Com 13cv, era
    divertido, mas nada desportivo. Contudo, no ano seguinte ao lançamento a
    Fiat apressou-se a lançar uma versão mais apimentada, de seu nome 500 Sport.
    Com apenas mais 20cc de cilindrada, chegava agora aos 21,5cv e complementada
    essa energia extra com uma aparência cativante, graças a faixas nos flancos
    e jantes em vermelho.
  </div>

  <div class="pl-28 pr-28 grid grid-cols-2 gap-4">
    <div class="bg-slate-200 h-[382px] w-full"></div>
    <div class="bg-slate-200 h-[382px] w-full"></div>
  </div>

  <div class="pl-56 pr-56 flex items-center text-base leading-4xl text-gray60-500 mt-10 mb-10">
    Na sucessão ao 500, vieram o 600 e o 126, que apesar de terem merecido o
    tratamento desportivo pela Abarth e Giannini, não tiveram nenhuma versão
    desportiva oficial.
  </div>

  <div class="pl-56 pr-56 flex items-center mb-16">
    <div class="border-l-4 border-primary pl-6 ml-8 text-3xl leading-4xl font-semibold text-primary">
      A autoria do desenho da carroçaria é atribuído a Ermanno Cressoni, que
      dirigiu o Centro Stile Alfa Romeo e depois o Centro Stile Fiat.
    </div>
  </div>

  <div class="pl-56 pr-56 flex items-center text-base leading-4xl text-gray60-500 mt-10 mb-16">
    Em 1991 surge o Cinquecento, código interno Type 170. A ideia de usar o nome
    por extenso, ajudou a a fomentar o afecto pelo modelo e a posicioná-lo
    simultaneamente como algo acessível, mas glamoroso. Já desde o início dos
    anos 80 que a Fiat estudava conceitos para um automóvel citadino, mais
    sofisticado que o Panda, mas igualmente barato de produzir. Tudo se
    precipitou com a aquisição da empresa polaca FSM, (empresa até então apenas
    parcialmente detida pela Fiat), que produzia os 126 e passou a produzir os
    Cinquecento, em Biesko-Biala.
  </div>

  <div class="pl-28 pr-28 grid grid-cols-2 gap-4">
    <div class="bg-slate-200 col-span-1 h-[382px] w-full"></div>
    <div class="bg-slate-200 col-span-1 h-[382px] w-full"></div>
    <div class="bg-slate-200 col-span-2 h-[733px] w-full"></div>
  </div>

  <div class="pl-56 pr-56 flex items-center text-base leading-4xl text-gray60-500 mt-10 mb-16">
    Mais moderno e mais pequeno, o 500 “Topolino”, foi o primeira da linhagem
    500, e nunca teve uma versão desportiva oficial, apesar de ter servido de
    base para inúmeros preparadores e construtores independentes.
    <br /><br />
    A este sucedeu o popular 500 Nuova, em 1957 (e até 1975). Com 13cv, era
    divertido, mas nada desportivo. Contudo, no ano seguinte ao lançamento a
    Fiat apressou-se a lançar uma versão mais apimentada, de seu nome 500 Sport.
    Com apenas mais 20cc de cilindrada, chegava agora aos 21,5cv e complementada
    essa energia extra com uma aparência cativante, graças a faixas nos flancos
    e jantes em vermelho.
  </div>

  <div class="pl-28 pr-28 grid grid-cols-2 gap-4">
    <div class="bg-slate-200 h-[382px] w-full"></div>
    <div class="bg-slate-200 h-[382px] w-full"></div>
  </div>

  <div class="pl-56 pr-56 flex items-center text-base leading-4xl text-gray60-500 mt-10 mb-16">
    Em 1994 foi dada a luz verde a uma versão desportiva, com o motor Fire
    1108cc. O novo director do Centro Stile, Chris Bangle, atribuiu a Luciano
    Bove (foi o seu primeiro trabalho) e a uma pequena equipa, a
    responsabilidade de criar uma estética específica, no interior e no
    exterior. O Sport foi responsável por 13% das vendas do Cinquecento e foi
    vendido em cinco cores: amarelo, vermelho, preto e, posteriormente em
    cinzento e azul metalizados.
    <br /><br />
    A Fiat estudou ainda a produção de uma versão com motor 16 válvulas e 80cv,
    cujo protótipo raramente foi visto a acredita-se que já não exista.
    Distinguia-se por uma enorme “bossa” artesanal no capot. Em 1998, o
    Cinquecento seria substituído pelo Seicento, que era essencialmente um
    restyling. A carroçaria cresceu nove centímetros para beneficiar o espaço
    interior, ganhando também cerca de 50kg. O tablier era totalmente novo e com
    um estilo mais moderno. A versão Sport em tudo semelhante, estando também
    disponível um kit Abarth.
  </div>

  <div class="pl-28 pr-28 grid grid-cols-3 gap-4">
    <div class="bg-slate-200 h-[244px] w-full"></div>
    <div class="bg-slate-200 h-[244px] w-full"></div>
    <div class="bg-slate-200 h-[244px] w-full"></div>
  </div>

  <div class="pl-56 pr-56 flex items-center text-base leading-4xl text-gray60-500 mt-10 mb-10">
    Com o nascimento do novo 500 e o renascimento da Abarth como sub-marca da
    Fiat, as versões desportivas ganharam ainda mais importância na gama e
    tornaram-se bastante sérias, com potências até aos 190cv.
  </div>
  <div class="pl-56 pr-56">
    <widget-spacer></widget-spacer>
  </div>

  <div class="pl-56 pr-56 flex justify-between">
    <div class="flex">
      <a href="#"
        class="footer__social--item w-10 h-10 rounded-full border border-primary text-primary flex justify-center items-center hover:bg-primary hover:text-white mr-2">
        <mat-icon svgIcon="feather:facebook" color="primary" class="hover:text-white"></mat-icon>
      </a>
      <a href="#"
        class="footer__social--item w-10 h-10 rounded-full border border-primary text-primary flex justify-center items-center hover:bg-primary hover:text-white">
        <mat-icon svgIcon="feather:instagram" color="primary" class="hover:text-white"></mat-icon>
      </a>
    </div>
    <div>
      <button mat-stroked-button color="primary" class="rounded-none border-primary mr-4">
        DESPORTIVOS
      </button>
      <button mat-stroked-button color="primary" class="rounded-none border-primary">
        DESPORTIVOS
      </button>
    </div>
  </div>
</div> -->
<!--
<div class="w-full bg-gray10-500">
  <div class="mx-auto max-w-screen-xl p-14">
    Component generico de comentários
  </div>
</div>

<div class="w-full mx-auto max-w-screen-xl">
  <widget-product-group [widget]="{
      numberOfColumns: 3,
      name: 'Em leilão',
      numberOfProducts: 3,
      showImage: true
    }"></widget-product-group>
</div>
<div class="w-full mx-auto max-w-screen-xl pb-7">
  <widget-news [widget]="{ layoutFormat: 'xLine', name: 'Mais artigos' }"></widget-news>
</div> -->
